import React from 'react';
import { Route, Switch } from 'react-router-dom';

// Roots
import MainLayout from 'layouts/main/MainLayout';
import PublicLayout from 'layouts/public/PublicLayout';
import RegistrationLayout from 'layouts/public/RegistrationLayout';

export const Root = () => (
    <Switch>
      <Route path="/public/registration" component={RegistrationLayout} />
      <Route path="/public" component={PublicLayout} />
      <Route path="/" component={MainLayout} />
    </Switch>
);



// WEBPACK FOOTER //
// ./src/modules/app/Routes.js